import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function FailedSolutions() {
  return <section className="py-8 md:py-12 px-4 md:px-6" style={{
    backgroundColor: 'var(--bg-deep)'
  }} data-id="element-159">
      <div className="max-w-[680px] mx-auto" data-id="element-160">
        <h2 className="text-xl md:text-3xl font-serif text-[var(--text-heading)] mb-5 md:mb-8 text-center" data-id="element-161">
          Por qué todo lo que intentaste{' '}
          <span className="text-[var(--text-muted)] italic text-lg md:text-2xl" data-id="element-162">
            no funcionó
          </span>
        </h2>

        <div className="space-y-3 md:space-y-5 text-base md:text-lg text-[var(--text-primary)] leading-relaxed" data-id="element-163">
          <p data-id="element-164">
            El 93% de los indocumentados nunca obtendrán estatus legal por las
            vías tradicionales. Has intentado todo: esperar, pagar abogados,
            esconderte.{' '}
            <strong className="text-[var(--text-heading)]" data-id="element-165">Ya basta.</strong>
          </p>

          <div className="grid gap-2 md:gap-3" data-id="element-166">
            {['La Reforma Mágica: 20 años de promesas vacías.', 'Notarios y "Consultores": Miles perdidos sin papeles reales.', '"Aguantando": El miedo te está matando antes que cualquier deportación.', 'Ignorar el Mundo: Creer que solo EE.UU. tiene oportunidades.'].map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start gap-3 p-3 md:p-4 bg-[var(--bg-elevated)] rounded border border-transparent" data-id="element-167">
                <X className="w-4 h-4 text-[var(--red-emphasis)] flex-shrink-0 mt-0.5" data-id="element-168" />
                <p className="text-[var(--text-muted)] text-sm md:text-base" data-id="element-169">
                  {item}
                </p>
              </motion.div>)}
          </div>

          <div className="mt-3 p-4 md:p-5 border-l-2 border-[var(--red-emphasis)] bg-[var(--red-emphasis)]/5" data-id="element-170">
            <p className="text-[var(--text-heading)] font-serif italic text-lg md:text-xl mb-1.5" data-id="element-171">
              Y entonces vino la desesperación.
            </p>
            <p className="text-[var(--text-muted)] text-sm md:text-base" data-id="element-172">
              <em data-id="element-173">
                "Si me voy, pierdo todo lo que he construido. No hay futuro
                fuera de aquí."
              </em>
            </p>
            <p className="text-[var(--text-primary)] mt-1.5 text-sm md:text-base" data-id="element-174">
              Esa es la mentira más destructiva que existe.
            </p>
          </div>

          <div className="bg-[var(--bg-elevated)] rounded-lg p-4 md:p-6 border border-[var(--accent)]/20 mt-3" data-id="element-175">
            <p className="text-[var(--accent)] font-bold font-serif text-base md:text-lg mb-1.5" data-id="element-176">
              La verdad:
            </p>
            <p className="text-[var(--text-primary)] text-sm md:text-base" data-id="element-177">
              El problema no eres tú. El problema es el sistema.{' '}
              <strong className="text-[var(--text-heading)]" data-id="element-178">
                Necesitas una salida estratégica.
              </strong>
            </p>
          </div>
        </div>
      </div>
    </section>;
}